export default __webpack_public_path__ + "static/media/fastingtime@2x.4ae1ec42.jpg";